import React from 'react';
import PropTypes from 'prop-types';
import { LetterAvatarSpan } from './LetterAvatarStyled';

// React-Wrapper-Pflichtmuster (wie Card.jsx): reicht `className` durch, damit
// Konsumenten via styled(LetterAvatar) eigenes Layout ergaenzen koennen.
// LETTER_AVATAR_BG: Token-Schluessel fuer die zentrale Farbe (secondaryLight=navy,
// warning=orange). Konsumenten setzen `fontSize` IMMER explizit (kein gefaehrlicher
// Default, der die alten 55px/18px still vereinheitlichen wuerde).
export const LETTER_AVATAR_BG = { SECONDARY_LIGHT: 'secondaryLight', WARNING: 'warning' };

const LetterAvatar = ({
  className, children, bg, fontSize, absolute, ...rest
}) => (
  <LetterAvatarSpan
    className={className}
    bg={bg}
    fontSize={fontSize}
    absolute={absolute}
    {...rest}
  >
    {children}
  </LetterAvatarSpan>
);

LetterAvatar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  bg: PropTypes.string,
  fontSize: PropTypes.number.isRequired,
  absolute: PropTypes.bool,
};

LetterAvatar.defaultProps = {
  className: undefined,
  children: null,
  bg: LETTER_AVATAR_BG.SECONDARY_LIGHT,
  absolute: false,
};

export default LetterAvatar;
